import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function getFloorplans(modelId, callback) {
	var storageRef = firebase
		.storage()
		.ref(PROJECT_CODE.projectCode + '/floorPlans/' + modelId);

	var filesArr = [];
	let promises = storageRef.listAll().then(function (result) {
		result.items.forEach(function (imageRef) {
			var fileExplorerFiles;
			imageRef.getDownloadURL().then(function (url) {
				console.log('imnagerefff', imageRef);
				var imageName = imageRef.name;
				if (imageName.slice(imageName.length - 3) === 'pdf') {
					fileExplorerFiles = {
						fileName: imageName.replace(
							'.png' || '.jpg' || '.jpeg',
							' '
						),
						href: url,
					};

					filesArr.push(fileExplorerFiles);
				}
			});
		});
	});

	setTimeout(() => {
		callback(filesArr);
	}, 1000);
}
